import { defineComponent } from 'vue';
import Footer from '@/components/common/Footer.vue';
import Banner from '@/components/common/Banner.vue';
import AliPlayer from '@/components/AliPlayer/index.vue';
import { createMeetingOrder, applyMeeting, getMeetingDetail, meetingIsFree, createFreeOrder, operationVideos } from '@/api/meeting';
import { appPort, getUserId, userLogin, jumpModuleApp, weixinShare, isLogin, versionCompare } from '@/widget/index';
// import Player from '@com/common/Player.vue'
import { hostPath } from '@/public/utils/basePath';
import { customerAct } from '@/api/data';
import { videoReq, meetReq } from '@/api/index';
export default defineComponent({
    data() {
        return {
            videosDetail: {},
            source: '',
            drmOptions: null,
            detail: {},
            bannerStyle: {
                height: '5.62rem',
                width: '7.5rem'
            },
            banner: [],
            userId: getUserId(),
            videoMd5: '',
            autoplay: 3000,
            playingInd: 0,
            tabInd: 1,
            scrollTop: 0,
            contentTop: 0,
            isApp: appPort(),
            freeBl: false,
            meetingId: this.$route.params.id,
            type: this.$route.params.type,
            showVipFreeDialog: false,
            orderId: ''
        };
    },
    computed: {
        btnText() {
            if (this.detail.status === 1) {
                if (this.isApp) {
                    return this.detail.payType !== 1 && !this.detail.isBuy
                        ? '已报名'
                        : '点击学习';
                }
                else {
                    return this.detail.payType !== 1 && !this.detail.isBuy
                        ? '已报名'
                        : '请打开【好医术】APP练习';
                }
            }
            else {
                // 当前用户是否可以免费报名
                if (this.detail.userIsFree) {
                    return this.detail.userIsFreeText;
                }
                return this.detail.statusText;
            }
        }
    },
    methods: {
        // 创建会员免费订单
        // 报名下单时 静默跳过 0元支付流程
        async confirmOrder() {
            this.$showLoading();
            meetReq
                .updateOrder({ userId: this.userId, orderId: this.orderId })
                .then(res => {
                if (res.code === 200) {
                    this.showVipFreeDialog = false;
                    this.getDetail();
                }
                else {
                    this.$toast(res.message + ' 错误码：' + res.code);
                }
            });
        },
        createOrder() {
            if (!isLogin) {
                userLogin();
                return;
            }
            if (this.freeBl) {
                this.$showLoading();
                createFreeOrder({
                    userId: this.userId,
                    meetingId: this.meetingId
                }).then(res => {
                    this.$hideLoading();
                    if (res.code === 200) {
                        this.orderId = res.data;
                        this.showVipFreeDialog = true;
                    }
                    else {
                        this.$toast(res.message);
                    }
                });
            }
            else {
                if (appPort()) {
                    jumpModuleApp({
                        typeId: 'vip_member_open'
                    });
                }
                else {
                    location.href = `${hostPath}/open_vip`;
                }
            }
        },
        viewVideo(item) {
            if (item.lock) {
                return false;
            }
            window.location.href = `/international/detail?id=${item.albumId}`;
        },
        openVip() {
            if (!isLogin) {
                userLogin();
                return;
            }
            if (appPort()) {
                jumpModuleApp({
                    typeId: 'vip_member_open'
                });
            }
            else {
                location.href = `${hostPath}/open_vip`;
            }
        },
        getOperationVideos() {
            operationVideos({
                userId: this.userId,
                meetingId: this.meetingId
            }).then(res => {
                if (res.code === 200) {
                    this.videosDetail = res.data;
                }
            });
        },
        beforeAliPlayerCreated({ key, videoId }) {
            this.playingInd = key;
            return new Promise(resolve => {
                videoReq
                    .getVideoUrl({ params: { videoId: videoId } })
                    .then(res => {
                    if (Number(res.code) === 200) {
                        resolve({ SD: res.data.ssl_url });
                    }
                    else {
                        this.$toast(res.message);
                    }
                })
                    .catch(error => {
                    console.log(error);
                });
            });
        },
        apply() {
            if (isLogin) {
                let type = this.$route.params.type.toUpperCase();
                let id = Number(this.meetingId) || 0;
                // detail.status -1 已结束 0 未报名 1 已报名
                if (this.detail.status === 1 && this.detail.payType !== 1) {
                    // 已报名线下支付
                    if (this.detail.isBuy) {
                        jumpModuleApp({
                            typeId: 'exercise_home',
                            dataId: id,
                            type: type
                        });
                    }
                    return;
                }
                if (this.detail.status === 1) {
                    if (this.isApp) {
                        jumpModuleApp({
                            typeId: 'exercise_home',
                            dataId: id,
                            type: type
                        });
                    }
                    else {
                        window.open('https://datayi.cn/bLbjaaidWmmO');
                    }
                    return;
                }
                else if (this.detail.status !== 0) {
                    return;
                }
                if (this.detail.payType !== 1) {
                    // 线下支付
                    applyMeeting({
                        userId: this.userId,
                        meetingId: id,
                        sourceId: this.$route.query.sourceId || '0'
                    }).then(res => {
                        if (res.code === 200) {
                            this.$dialog.alert({
                                title: '提示',
                                messageAlign: 'left',
                                message: res.data,
                                confirmButtonText: '确定'
                            });
                            this.detail.status = 1;
                        }
                        else {
                            this.$toast(res.message);
                        }
                    });
                }
                else {
                    createMeetingOrder({
                        userId: this.userId,
                        meetingId: id
                    }, {
                        sourceId: this.$route.query.sourceId || '0'
                    }).then(res => {
                        if (res.code === 200) {
                            this.$router.push({
                                name: 'orderDetail',
                                params: {
                                    module: 'meeting',
                                    orderId: res.data
                                }
                            });
                        }
                        else {
                            this.$toast(res.message);
                        }
                    });
                }
            }
            else {
                userLogin();
            }
        },
        getDetail() {
            this.$showLoading();
            getMeetingDetail({
                userId: this.userId,
                meetingId: this.meetingId
            }).then(res => {
                this.$hideLoading();
                if (res.code === 200) {
                    this.detail = res.data;
                    this.banner = res.data.banners;
                    let shareInfo = res.data.share || '';
                    document.title = this.detail.meetingName;
                    shareInfo &&
                        weixinShare({
                            title: shareInfo.title,
                            url: shareInfo.url,
                            desc: shareInfo.desc,
                            image: shareInfo.image
                        });
                }
                else {
                    this.$toast(res.message);
                }
            });
            // 是否享有会员免费权益
            meetingIsFree({
                userId: this.userId,
                meetingId: this.meetingId
            }).then(res => {
                this.$hideLoading();
                if (res.code === 200) {
                    this.freeBl = res.data;
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        // playVideo(md5: string, key: string | number) {
        //   this.videoMd5 = md5
        //   this.autoplay = 0
        //   this.playingInd = key
        //   this.$refs['videoPlayer' + key].playVideo()
        // },
        swipeChange(current) {
            const index = current - 1 >= 0 ? current - 1 : this.banner.length - 1;
            if (this.$refs['videoPlayer' + index]) {
                this.$refs['videoPlayer' + index].aliPlayer.pause();
            }
        },
        scroll() {
            this.scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (this.$refs.detail2) {
                var outlineTop = this.$refs.detail2.offsetTop;
            }
            if (this.$refs.outlineTop3) {
                var outlineTop3 = this.$refs.detail3.offsetTop;
            }
            if (this.scrollTop >= outlineTop3 - 88) {
                this.tabInd = 3;
            }
            else if (this.scrollTop >= outlineTop - 88) {
                this.tabInd = 2;
            }
            else {
                this.tabInd = 1;
            }
        },
        scrollFn() {
            window.addEventListener('scroll', this.scroll, false);
        },
        chooseTab(n) {
            this.tabInd = n;
            let rem = Number(localStorage.getItem('rem'));
            let num = Number((88 * rem) / 100);
            let top = 0;
            if (n === 1) {
                top = this.contentTop;
            }
            if (n === 2) {
                top = this.$refs.detail2.offsetTop - num;
            }
            if (n === 3) {
                top = this.$refs.detail3.offsetTop - num;
            }
            window.scrollTo({
                top: top
            });
        },
        serviceFn() {
            if (this.isApp && versionCompare('6.0.1')) {
                jumpModuleApp({
                    typeId: 'online_consulting',
                    dataId: this.meetingId,
                    type: 'meeting'
                });
            }
            else {
                location.href = `${hostPath}/user/service?meetingId=${this.meetingId}`;
            }
        },
        customerAct() {
            let extraData;
            if (this.type === 'omo') {
                extraData = 'omo_exercise_browse';
            }
            else {
                extraData = 'online_exercise_browse';
            }
            if (this.userId) {
                customerAct({
                    userId: this.userId,
                    typeText: extraData
                }, {
                    extra: JSON.stringify({
                        meetingId: this.meetingId
                    })
                });
            }
        }
    },
    mounted() {
        this.getDetail();
        this.customerAct();
        this.$nextTick(() => {
            this.contentTop = this.$refs.contentDetail.offsetTop;
            this.scrollFn();
        });
        this.getOperationVideos();
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, false);
    },
    components: {
        Footer,
        Banner,
        AliPlayer
    }
});
